import { BaseModel } from '../../_base/crud';
export class Product extends BaseModel {
    id: number;
    name: string;
    clear(){
        this.id = undefined;
        this.name = "";
    }
}

export class ProductType extends BaseModel {
    id: number;
    name: string;
    clear(){
        this.id = undefined;
        this.name = "";
    }
}

export class ProductVariety extends BaseModel {
    id: number;
    name: string;
    clear(){
        this.id = undefined;
        this.name = "";
    }
}